import request from '../request';

export function index(params) {
  return request({
    url: "/driver/manage-deliveries",
    method: "get",
    params
  })
}

export function update(id) {
  return request({
    url: `/driver/manage-deliveries/${id}`,
    method: "put",
  })
}